import React from "react";
import { useAsync } from "react-async";
import { getMayTermInfo } from "services";
import { MayTermCard } from "./MayTermCard";

export function MayTermList(): JSX.Element {
  const { data } = useAsync({ promiseFn: getMayTermInfo });

  return (
    <>
      {data &&
        data
          .filter(mayTerm => mayTerm.display === true)
          .map(mayTerm => <MayTermCard key={mayTerm.id} mayTerm={mayTerm} />)}
    </>
  );
}
